var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EpbCheckbox',{class:_vm.baseClass,attrs:{"value":_vm.isItemSelected,"disabled":_vm.disabled},on:{"input":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }